'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CommonContainer from '@components/CommonContainer';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import cn from './style.module.scss';
export default function LsqSodicWelcome(props: MarketingPageComponentProps) {
  const welcomeSection = props?.locale?.section?.find(
    (section: any) => section.type === 'welcome' && section.enabled
  );
  if (!welcomeSection) return null;
  return (
    <Stack
      component="section"
      className={cn.sodicWelcomeWrapper}
      id="sodicWelcome"
    >
      <Box className={cn.sodicWelcomeInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.sodicWelcomeContent}>
            <Box
              className={cn.sodicWelcomeHeading}
              {...mergeAos(fadeUpAosProps, getAosDelay(400))}
            >
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  welcomeSection?.lsqSodicWelcomeContent?.heading
                )}
              </ParallaxText>
              <ParallaxText
                variant="h4"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  welcomeSection?.lsqSodicWelcomeContent?.subHeading
                )}
              </ParallaxText>
              <ParallaxText
                variant="p"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  welcomeSection?.lsqSodicWelcomeContent?.tagline
                )}
              </ParallaxText>
            </Box>
            <Box className={cn.sodicWelcomeData}>
              <ParallaxText
                variant="p"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(welcomeSection?.lsqSodicWelcomeContent?.data)}
              </ParallaxText>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
